<div class="tt-c-reply">
  <p class="tt-c-reply__text" v-html="reply.text"></p>
  <tt-byline ref="byline" class="tt-c-reply__byline" :item="reply" ugcType="sr" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-byline>
  <tt-reply-form v-if="showReplyForm"
                 :id="controlsId"
                 :answerId="answerId"
                 :originSiteKey="originSiteKey"
                 parentType="reply"
                 :parent="reply"
                 :questionId="questionId"
                 :submissionCtx="submissionCtx"
                 @close="closeForm"></tt-reply-form>
  <div :class="['tt-c-reply__list', {'tt-c-reply__list--nested': depth < 4 }]">
    <reply v-for="nestedReply in reply.replies"
           :answerId="answerId"
           :openReplyForReplyId="openReplyForReplyId"
           :originSiteKey="originSiteKey"
           :questionId="questionId"
           :reply="nestedReply"
           :depth="depth + 1"
           :submissionCtx="submissionCtx"
           :key="nestedReply.id"></reply>
  </div>
</div>
